import Post, {IPost} from '@/models/Post'
import {IMedium, Medium} from '@/models/Medium'
import { KeyPair } from '@/types/KeyPair'

export interface IInterview extends IPost {
  recruit_url?: string
  read_content?: string
  profile_image?: IMedium
  profile_company_name?: string
  profile_name?: string
  profile_position?: string
  profile_content?: string
}

export default class Interview extends Post {
  recruit_url?: string
  read_content?: string
  profile_image?: Medium
  profile_company_name?: string
  profile_name?: string
  profile_position?: string
  profile_content?: string

  constructor(defaults?: IInterview) {
    super(defaults)
    if (defaults) {
      this.recruit_url = defaults.recruit_url
      this.read_content = defaults.read_content
      this.profile_image = defaults.profile_image ? new Medium(defaults.profile_image) : undefined
      this.profile_company_name = defaults.profile_company_name
      this.profile_name = defaults.profile_name
      this.profile_position = defaults.profile_position
      this.profile_content = defaults.profile_content
    }
  }

  get className(): string {
    return Interview.name
  }

  toParams(): KeyPair {
    return Object.assign({}, super.toParams(), {
      recruit_url: this.recruit_url,
      read_content: this.read_content,
      profile_image_id: this.profile_image?.id || null,
      profile_company_name: this.profile_company_name,
      profile_name: this.profile_name,
      profile_position: this.profile_position,
      profile_content: this.profile_content,
    })
  }
}
